import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-y-small', 'LetterYSmall', [["path",{"d":"M10 8l2 5l2 -5"}],["path",{"d":"M12 16v-3"}]]);